/*eslint-disable */
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let AdminEmailTemplateApiObj = {
  /**
   * adminEmailTemplateList
   */
  async adminEmailTemplateList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "admin_email_template_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at adminEmailTemplateList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * adminEmailTemplateView
   */
  async adminEmailTemplateView (context, adminemailtempId) {
    try {      
      let post_data = new FormData();
      post_data.append('email_template_id', adminemailtempId);
      return await request.curl(context, "admin_email_temp_View", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at adminEmailTemplateView() and Exception:",err.message)
    }    
  },

  /**
   * adminEmailTemplateAdd
   */
  async adminEmailTemplateAdd (context, adminemailtempObj) {
    try{
      let post_data = new FormData();
    
      for (let key in adminemailtempObj) {
        post_data.append(key, adminemailtempObj[key]);
      }

      return await request.curl(context, "admin_email_template_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at adminEmailTemplateAdd() and Exception:',err.message)
    }
  },

  /**
   * adminEmailTemplateEdit
   */
  async adminEmailTemplateEdit (context, adminemailtempObj) {
    try{
      let post_data = new FormData();
    
      for (let key in adminemailtempObj) {
        post_data.append(key, adminemailtempObj[key]);
      }

      return await request.curl(context, "admin_email_template_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at adminEmailTemplateEdit() and Exception:',err.message)
    }
  },

  /**
   * adminEmailTemplateDelete
   */
  async adminEmailTemplateDelete (context, adminemailtempId) {
    try{
      let post_data = new FormData();
      
      post_data.append('email_template_id', adminemailtempId);

      return await request.curl(context, "admin_email_template_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at adminEmailTemplateDelete() and Exception:',err.message)
    }
  },
  /**
   * Admin Email Template FilterList
   */
  async adminEmailTemplateFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "admin_email_template_filterList", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at admin_email_template_filterList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  AdminEmailTemplateApiObj
}
